module.exports = __webpack_public_path__ + "img/co-investing4.093c92ba.svg";